import React from "react";
import { TextField, Button } from '@material-ui/core';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FillInFormTable from "hearing/components/questionnaire/aphab-b/fill-in-form-table";
import QuestionTable from "hearing/components/questionnaire/aphab-b/question-table";
import axios from 'axios';
import {P1, P2, P3} from 'assets/fonts';
import FontComponent from 'assets/font-ui';
import ExampleTable from "hearing/components/questionnaire/aphab-a/example-table";
import Modal from 'hearing/components/partials/modal';


class AphabB extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      participantID: null,
      studyID: null,
      date: null,
      SSN: null,
      formQuestion: {
        "1": null,
        "2": null,
        "3": null
      },
      choiceQuestion: {
        "The sound of a fire engine siren close by is so loud that I need to cover my ears.": {
          without: null,
          with: null
        },
        "When a speaker is addressing a small group, and everyone is listening quietly, I have to strain to understand.": {
          without: null,
          with: null
        },
        "It’s hard for me to understand what is being said at lectures or church services.": {
          without: null,
          with: null
        },
        "When I’m at the dinner table with several people, and am trying to have a conversation with one person, understanding speech is difficult.": {
          without: null,
          with: null
        },
        "When I am in a theater watching a movie or play, and the people around me are whispering and rustling paper wrappers, I can still make out the dialogue.": {
          without: null,
          with: null
        },
        "When I’m in a quiet conversation with my doctor in an examination room, it is hard to follow the conversation.": {
          without: null,
          with: null
        },
        "When I am listening to the news on the car radio, and family members are talking, I have trouble hearing the news.": {
          without: null,
          with: null
        },
        "The sounds of running water, such as a toilet or shower, are uncomfortably loud.": {
          without: null,
          with: null
        },
        "When I am having a quiet conversation with a friend, I have difficulty understanding.": {
          without: null,
          with: null
        },
        "I can understand conversations even when several people are talking.": {
          without: null,
          with: null
        },
        "The sounds of construction work are uncomfortably loud.": {
          without: null,
          with: null
        },
        "I have trouble understanding others when an air conditioner or fan is on.": {
          without: null,
          with: null
        },
        "I have trouble understanding the dialogue in a movie or at the.": {
          without: null,
          with: null
        },
        "Traffic noises are too loud.": {
          without: null,
          with: null
        },
        "When I am in a small office, interviewing or answering questions, I have difficulty following the conversation.": {
          without: null,
          with: null
        },
        "I miss a lot of information when I’m listening to a lecture.": {
          without: null,
          with: null
        },
        "I have to ask people to repeat themselves in one-on-one conversation in a quiet room.": {
          without: null,
          with: null
        },
        "Unexpected sounds, like a smoke detector or alarm bell are uncomfortable.": {
          without: null,
          with: null
        },
        "I can follow the words of a sermon when listening to a religious service.": {
          without: null,
          with: null
        },
        "When I am in a crowded grocery store, talking with the cashier, I can follow the conversation.": {
          without: null,
          with: null
        },
        "I can communicate with others when we are in a crowd.": {
          without: null,
          with: null
        },
        "The sound of screeching tires is uncomfortably loud.": {
          without: null,
          with: null
        },
        " I have difficulty hearing a conversation when I’m with one of my family at home.": {
          without: null,
          with: null
        },
        "When I am talking with someone across a large empty room, I understand the words.": {
          without: null,
          with: null
        }
      },
      errorText: [],
      modalOpen: false,
    }
  };

  componentDidMount = async () => {
    await axios.post('/api/hearing/visit', { page: 'hearing/questionnaire/aphab/b' });
  };

  handleCheckBoxClick = (num, choice) => {
    const { formQuestion } = this.state;
    formQuestion[String(num)] = choice;
    this.setState({ formQuestion });
  }

  handleChoiceClick = (question, type, answer) => {
    const { choiceQuestion } = this.state;
    choiceQuestion[question][type] = answer;
    this.setState({ choiceQuestion });
  }

  handleModalClose = () => {
    window.location = "/hearing/questionnaire";
  }

  handleSubmit = async () => {
    await axios.post('/api/hearing/aphabb/user', this.state);
    this.setState({ modalOpen: true });
  } 

  render(){
    const { errorText, date, modalOpen, participantID, studyID, formQuestion, choiceQuestion } = this.state;
    return(
      <div style={{ backgroundColor: "rgb(240,240,240)", fontFamily: "raven", height: window.innerHeight, overflowY: "scroll"}}>
        <div style={{margin: "3%"}}>
          <div id="title">
            <center><P1>ABBREVIATED PROFILE OF HEARING AID BENEFIT</P1></center>
            <center><P1>Form B</P1></center>
          </div>
          <div id="demo-form" style={{ marginTop: "20px" }}>
            <div id="nameAndDate" style={{marginLeft: "30px"}}>
              <div className="col-8 row" style={{marginTop: "10px" }}>
                <P2>Participant ID: </P2><TextField id="id" value={participantID} onChange={e => this.setState({participantID: e.target.value})} style={{width: "50%", marginBottom: "10px", marginLeft: "0px"}}/>
              </div>
              <div className="col-8 row" style={{marginTop: "10px"}}>
                <P2>Study ID: </P2><TextField id="id" value={studyID} onChange={e => this.setState({studyID: e.target.value})} style={{width: "50%", marginBottom: "10px", marginLeft: "45px"}}/>
              </div>
              <div className="col-8 row" style={{marginTop: "5px"}}>
                <P2 style={{marginRight: "3px"}}>TODAY'S DATE: </P2><DatePicker selected={date} onChange={date => this.setState({date})} />  
              </div>
            </div>
          </div>
          <div className="jumbotron" style={{margin: "20px"}}>
            <div id="instruction">
            <P2>INSTRUCTIONS</P2>
              <div className="row">
                <div className="col-8">
                  <P2>
                    Please circle the answers that come closest to your
                    everyday experience. Notice that each choice includes a
                    percentage. You can use this to help you decide on your
                    answer. For example, if the statement is true about 75%
                    of the time, circle C for that item. If you have not
                    experienced the situation we describe, try to think of a
                    similar situation that you have been in and respond for
                    that situation. If you have no idea, leave that item blank.
                  </P2>
                </div>
                <div className="col-4">
                  <ul  style={{ fontSize: "15px", outlineWidth: "2px", outlineColor: "black", outlineStyle: "auto" }}>
                    <P2><li><b>A</b> Always (99%)</li></P2>
                    <P2><li><b>B</b> Almost Always (87%)</li></P2>
                    <P2><li><b>C</b> Generally (75%)</li></P2>
                    <P2><li><b>D</b> Half-the-time (50%)</li></P2>
                    <P2><li><b>E</b> Occasionally (25%)</li></P2>
                    <P2><li><b>F</b> Seldom (12%)</li></P2>
                    <P2><li><b>G</b> Never (1%)</li></P2>
                  </ul>
                </div>
              </div>
            </div>
            <div id="example">
              <P2>EXAMPLE</P2>
              <P2>
                For some items, an answer of “Always (99%)” indicates few problems. Other items are
                written so that an answer of “Always (99%)” indicates a lot of problems. Here is an example.
                In item (a), below, an answer of “Always (99%)” means that you often have problems. In
                item (b), below, the same answer means that you seldom have problems.
              </P2>
              <ExampleTable />
            </div>
          </div>
          <div id="multiple-choice" style={{marginTop: "20px"}}>
            <QuestionTable questions={choiceQuestion} onChoiceClick={this.handleChoiceClick}/>
          </div>
          <div id="error" style={{color: "red", margin: "5%"}}>
            {errorText.length !== 0 && <P2>These questions are not completed.</P2>}
            <ul>
              {
                errorText.map(error => <li><P3>{error}</P3></li>)
              }
            </ul>
          </div>
          <div id="checkbox" style={{ marginTop: "20px" }}>
            <FillInFormTable answers={formQuestion} onCheckBoxClick={this.handleCheckBoxClick} />
          </div>
          <div id="submitButton">
            <Button 
              size="large" 
              varian="contained" 
              style={{
                color: "white", backgroundColor: "#107896",
                marginLeft: "45%", marginTop: "20px", marginBottom: "20px"
              }}
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
        <FontComponent />
        <Modal
          open={modalOpen}
          onClose={this.handleModalClose}
        />
      </div>
    )
  }
}

export default AphabB;